//
// Audio page
//
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ExhibitTitle from './ExhibitTitle';
import AudioStops from './AudioStops';

const AudioPage = ({ chooseLanguage, language }) => (
  <Fragment>
    <ExhibitTitle
      chooseLanguage={chooseLanguage}
      language={language}
    />
    <AudioStops language={language} />
  </Fragment>
);

AudioPage.propTypes = {
  chooseLanguage: PropTypes.func.isRequired,
  language: PropTypes.string,
};

AudioPage.defaultProps = {
  language: 'en',
};

export default AudioPage;



// WEBPACK FOOTER //
// ./src/AudioPage.js